import { ArrowRight, Check, ChevronDown, CircleDollarSign } from "lucide-react";
import { useState } from "react";
import { Link } from "../app/router";
import { PageMeta } from "../components/PageMeta";
import { SectionHeading } from "../components/SectionHeading";
import { servicePackages } from "../data/services";
import { formatMoney } from "../lib/format";

const faqs = [
  ["Dự toán trong demo đã gồm những gì?", "Tổng gồm đúng các dòng cây, chậu, nội thất, phụ kiện đang có trong bản phác và một phí gói dịch vụ."],
  ["Vì sao đây chưa phải báo giá thi công?", "Chưa có khảo sát hiện trạng, tải trọng, chống thấm, điện nước, vận chuyển, nội quy tòa nhà và tình trạng vật tư."],
  ["Tôi có thể chỉ lấy bản thiết kế?", "Có. Gói Bản Phác mô phỏng một phương án 2D, danh mục, dự toán và lịch chăm mà không có điều phối lắp đặt."],
  ["Form tư vấn có gửi thông tin không?", "Không. Toàn bộ thao tác chỉ chạy trong trình duyệt và biên nhận là trạng thái giả lập."],
];

export function ServicesPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  return (
    <>
      <PageMeta
        title="Gói thiết kế ban công | Rêu Nắng"
        description="Xem phạm vi gói, cách tính dự toán và những hạng mục cần khảo sát thực tế."
      />
      <section className="page-intro services-intro">
        <div className="container narrow">
          <span className="eyebrow">Phạm vi rõ trước khi nói giá</span>
          <h1>Chọn mức đồng hành, không mua một hộp bí ẩn.</h1>
          <p className="lead">Giá gói cộng một lần vào danh sách vật tư. Mọi hạng mục ngoài khảo sát được nói rõ ngay từ đầu.</p>
        </div>
      </section>
      <section className="section package-section">
        <div className="container package-grid">
          {servicePackages.map((service) => (
            <article className={`package-card ${service.featured ? "featured" : ""}`} key={service.id}>
              {service.featured && <span className="package-badge">Được chọn nhiều</span>}
              <span className="eyebrow">{service.leadTime}</span>
              <h2>{service.name}</h2>
              <p>{service.tagline}</p>
              <strong className="package-price">{formatMoney(service.price)}</strong>
              <ul>
                {service.deliverables.map((deliverable) => <li key={deliverable}><Check aria-hidden="true" /> {deliverable}</li>)}
              </ul>
              <Link className={`button ${service.featured ? "button-primary" : "button-secondary"}`} to={`/thiet-ke?package=${service.id}`}>
                Chọn {service.name} <ArrowRight aria-hidden="true" />
              </Link>
            </article>
          ))}
        </div>
      </section>
      <section className="section estimate-explainer">
        <div className="container explainer-grid">
          <div>
            <span className="eyebrow">Công thức không có hệ số ẩn</span>
            <h2>Giá hình thành từ những gì bạn nhìn thấy.</h2>
            <p>Mỗi lần thêm cây hay bỏ ghế, công cụ tính lại từ đơn giá gốc. Phí dịch vụ là một dòng riêng.</p>
          </div>
          <div className="formula-card">
            <CircleDollarSign aria-hidden="true" />
            <div><span>Cây × số lượng</span><b>+</b><span>Chậu & đồ</span><b>+</b><span>Gói dịch vụ</span></div>
            <strong>= Dự toán mô phỏng</strong>
          </div>
        </div>
      </section>
      <section className="section timeline-section">
        <div className="container">
          <SectionHeading eyebrow="Cách dịch vụ vận hành" title="Từ brief đến bàn giao, theo đúng thứ tự." />
          <ol className="service-timeline">
            {[
              ["01", "Nhận brief", "Kích thước, ảnh, nắng và nếp sống."],
              ["02", "Đối chiếu", "Cây, chậu, lối đi, an toàn và ngân sách."],
              ["03", "Chỉnh phương án", "Một vòng feedback ở gói Vừa Vặn."],
              ["04", "Khảo sát", "Chỉ có trong Trọn Góc; demo không thay thế khảo sát thật."],
            ].map(([number, title, body]) => <li key={number}><span>{number}</span><div><h3>{title}</h3><p>{body}</p></div></li>)}
          </ol>
        </div>
      </section>
      <section className="section faq-section">
        <div className="container faq-layout">
          <div><span className="eyebrow">Nói trước phần còn mờ</span><h2>Câu hỏi thường gặp.</h2></div>
          <div className="faq-list">
            {faqs.map(([question, answer], index) => (
              <div className="faq-item" key={question}>
                <h3>
                  <button type="button" aria-expanded={openFaq === index} onClick={() => setOpenFaq(openFaq === index ? null : index)}>
                    {question}<ChevronDown aria-hidden="true" />
                  </button>
                </h3>
                {openFaq === index && <p>{answer}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
